import Axios from 'axios';
import config from '../config/dev';
import User from '../helpers/user';

const httpClient = Axios.create({
    baseURL: config.ENDPOINT_BASE_URL,
    timeout: 60000,
    headers: {
        Accept: 'application/json',
    },
});

const addLoadingState = () => {
    document.body.classList.add('loading-body');
};

const removeLoadingState = () => {
    document.body.classList.remove('loading-body');
};

const getErrorStatus = (error) => {
    return error && error.response
        ? error.response.status
        : null;
};

const shouldShowGenericError = (status) => {
    return status !== 401 && status !== 422;
};

const createErrorReport = (error) => {
    const config = error && error.config
        ? error.config
        : {};

    const response = error && error.response
        ? error.response
        : {};

    return {
        message: error && error.message
            ? error.message
            : 'Unknown error',

        method: config.method,
        url: config.url,
        status: response.status,
        response: response.data,
    };
};

const reportError = async (error) => {
    const enabled =
        String(process.env.REACT_APP_SLACK_REPORT_ENABLED)
            .toLowerCase() === 'true';

    const webhookUrl =
        process.env.REACT_APP_SLACK_REPORT_WEBHOOK_URL;

    if (!enabled) {
        return;
    }

    if (!webhookUrl) {
        console.warn('Slack webhook URL is missing.');

        return;
    }

    try {
        await Axios.post(
            webhookUrl,
            {
                text: JSON.stringify(
                    createErrorReport(error),
                    null,
                    2,
                ),
            },
            {
                withCredentials: false,
            },
        );
    } catch (reportError) {
        console.error(
            'Error reporting failed:',
            reportError,
        );
    }
};

httpClient.interceptors.request.use(
    (requestConfig) => {
        addLoadingState();

        if (!User.isGuest()) {
            requestConfig.headers.Authorization =
                User.requireUser().auth_key;
        }

        if (process.env.NODE_ENV === 'development') {
            requestConfig.headers.XDEBUG_TRIGGER = '1';
        }

        return requestConfig;
    },
    (error) => {
        removeLoadingState();

        return Promise.reject(error);
    },
);

httpClient.interceptors.response.use(
    (response) => {
        removeLoadingState();

        return response;
    },
    async (error) => {
        removeLoadingState();

        const status = getErrorStatus(error);

        if (status === 401) {
            User.logout();

            return Promise.reject(error);
        }

        if (shouldShowGenericError(status)) {
            window.alert(
                'Váratlan hiba történt! Kérjük, frissítse a böngészőt.\n'
                + 'Ha a hiba továbbra is fennáll, kérjük, vegye fel '
                + 'a kapcsolatot az üzemeltetőkkel!',
            );

            await reportError(error);
        }

        return Promise.reject(error);
    },
);

export default httpClient;


// WEBPACK FOOTER //
// ./src/api/httpClient.js